import { render } from "./mapPresta.vue?vue&type=template&id=f0671e8c"
import script from "./mapPresta.vue?vue&type=script&lang=ts"
export * from "./mapPresta.vue?vue&type=script&lang=ts"
script.render = render

export default script